<template>
  <div class="app-main">
    <section>
      <transition name="fade-transform" mode="out-in">
        <router-view :key="key" />
      </transition>
    </section>
  </div>
</template>

<script>
import { startPulse } from '@/admin/js/services/pulse';

export default {
  name: 'AppMain',
  data() {
    return {
      processes: [],
      progressVisible: false,
      _pulse: null
    }
  },
  computed: {
    key() {
      return this.$route.fullPath
    },
  },
  mounted() {
    this._pulse = startPulse({
      endpoint: '/api/admin/pulse',
      baseInterval: 15000,
      jitter: 3000,
      page: () => this.$route.fullPath,
    });

    // отправить первый пинг сразу
    this._pulse.ping();
  },
  watch: {
    // пинг при смене маршрута (если вкладка активна)
    $route() {
      this._pulse?.ping?.();
    }
  },
  beforeDestroy() {
    this._pulse && this._pulse.stop();
  }
}
</script>
